import { render, staticRenderFns } from "./PageFiveElite.vue?vue&type=template&id=3f772bb6&scoped=true"
import script from "./PageFiveElite.vue?vue&type=script&lang=js"
export * from "./PageFiveElite.vue?vue&type=script&lang=js"
import style0 from "./PageFiveElite.vue?vue&type=style&index=0&id=3f772bb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f772bb6",
  null
  
)

export default component.exports